function shortenLongTextsInCouponFragment() {
    //Adding ellipsis to long product title
    var maxLength = 55;
    $('.dht--header').each(function () {
        shortenText($(this), maxLength);
    });

    $('.product--title').each(function () {
        shortenText($(this), maxLength);
    });
}

function shortenText($self, maxLength) {
    var text = $self.text();
    if (text.length > maxLength) {
        $self.text(text.substr(0, maxLength - 3) + ' …');
    }
}

function processCouponsDataLayerView() {
    var modalDetailsCoupon = $('.remodal article.coupon--bloc');
    $('article.coupon--bloc').not(modalDetailsCoupon).each(function () {
        var couponId = $(this).children('.coupon-addToCart').first().attr("data-coupon-metrocouponid");
        pushDataLayerCouponDisplay(loyaltyProgram, couponId);
    });
}

$('.coupon--bloc button:not(.coupons-ctc-legal)').on('mouseover focus', function () {
    $(this).closest('article.coupon--bloc').find('button:not(.coupons-ctc-legal)').addClass('coupon-hover--relay');
}).on('mouseout blur', function () {
    $(this).closest('article.coupon--bloc').find('button').removeClass('coupon-hover--relay');
});

$(document).on('closed', '.remodal-coupons-legal[data-remodal-id]', function () {
    // focus back on trigger after closing coupon remodal
    $('[data-remodal-target=' + $(this).attr('data-remodal-id') + ']').focus();
});

const Coupons = {
    bindCouponCardActionEvents: function (clipUrl, unclipBaseUrl, onSuccessCallback, onModalSuccessCallback) {
        Coupons.triggerCouponImpressionOnActiveCoupons();

        const $clickableClipUnclipButtons = $('.card-clip').not('.card-clip-mobile');
        $clickableClipUnclipButtons.on('click', function (event) {
            Coupons.actionOnCardButton($(this), clipUrl, unclipBaseUrl, onSuccessCallback);
            event.stopPropagation();
        }).on('keyup', function (event) {
            if (event.key === 'Enter') {
                // Prevent the underneath card to be clicked
                Coupons.actionOnCardButton($(this), clipUrl, unclipBaseUrl, onSuccessCallback);
                event.stopPropagation();
            }
        }).on('keydown', function (event) {
            // This prevents the keydown to be called
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        });

        // Setting the event on coupon click
        let $cardTileCoupon = $('.cardTileCoupon');
        const minMouseDrag = 6;
        let mouseDragX;
        let mouseDragY;
        $cardTileCoupon.on('mousedown', function (e) {
            mouseDragX = e.pageX;
            mouseDragY = e.pageY;
        }).on('keyup', function (event) {
            if (event.key === 'Enter') {
                Coupons.fillModalWithCouponInfo($(this), activeCoupons, clipUrl, unclipBaseUrl, onModalSuccessCallback);
            }
        }).on('keydown', function (event) {
            // This prevents the keydown to be called
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        });
        $cardTileCoupon.on('mouseup', function (e) {
            let $this = $(e.target);

            const mouseDragDiffX = Math.abs(e.pageX - mouseDragX);
            const mouseDragDiffY = Math.abs(e.pageY - mouseDragY);
            if (mouseDragDiffX < minMouseDrag && mouseDragDiffY < minMouseDrag) {
                if (!$this.hasClass('card-clip')) {
                    Coupons.fillModalWithCouponInfo($(this), activeCoupons, clipUrl, unclipBaseUrl, onModalSuccessCallback);
                }
            }
        });
    },
    actionOnCardButton: function ($couponActionButton, clipUrl, unclipBaseUrl, onSuccessCallback) {
        // Check if coupon is available
        const isAvailable = $couponActionButton.hasClass('available');
        const isClipped = $couponActionButton.hasClass('clipped');
        const $couponTile = $couponActionButton.parent();

        if (isAvailable) {
            Coupons.clipCoupon($couponTile, clipUrl, onSuccessCallback);
        }

        if (isClipped) {
            Coupons.unclipCoupon($couponTile, unclipBaseUrl, onSuccessCallback);
        }
    },
    getCoupon: function (couponContainer, couponBanner, couponTypeId, couponEligibilityId) {
        return $.grep(couponContainer, function (coupon) {
            return coupon.bannerCode === couponBanner && coupon.couponTypeId === couponTypeId && (couponEligibilityId ? coupon.eligibilityId === couponEligibilityId : true);
        })[0];
    },
    clipCoupon: function ($couponTile, url, successCallback) {
        const bannerCode = $couponTile.attr("data-cBanner");
        const typeId = $couponTile.attr("data-cTypeId");
        const eligibilityId = $couponTile.attr("data-cEligibilityId");
        const mobileOnly = $couponTile.attr("data-cMobile");

        let listOfCoupons = [Coupons.getCoupon(activeCoupons, bannerCode, typeId, eligibilityId)];
        $couponTile.addClass('in-progress');

        $.ajax({
            url: url,
            type: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify({'clippedCoupons': listOfCoupons}),
            headers: {
                'Accept-Language': lang
            },
            success: function(data) {
                pushDatalayerCouponClip(typeId, bannerCode, mobileOnly);
                $couponTile.removeClass('in-progress');
                successCallback(data)
            },
            error: function (jqXHR) {
                $couponTile.removeClass('in-progress');
                TINK.redirectIfConflict(jqXHR)
            }
        });
    },
    unclipCoupon: function ($couponTile, unclipBaseUrl, successCallback) {
        const bannerCode = $couponTile.attr("data-cBanner");
        const typeId = $couponTile.attr("data-cTypeId");
        const eligibilityId = $couponTile.attr("data-cEligibilityId");

        const couponToUnclip = Coupons.getCoupon(activeCoupons, bannerCode, typeId, eligibilityId);
        $couponTile.addClass('in-progress');

        $.ajax({
            url: unclipBaseUrl + '/' + couponToUnclip.couponId + '/unclip',
            type: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify({
                'couponId': couponToUnclip.couponId,
                'status': 'Clipped',
                'mobileOnlyCoupon': couponToUnclip.mobileOnlyCoupon
            }),
            headers: {
                'Accept-Language': lang
            },
            success: function (data) {
                $couponTile.removeClass('in-progress');
                successCallback(data);
            },
            error: function (jqXHR) {
                $couponTile.removeClass('in-progress');
                TINK.redirectIfConflict(jqXHR)
            }
        });
    },
    fillModalWithCouponInfo: function ($this, couponList, clipUrl, unclipBaseUrl, onModalSuccessCallback) {
        const $modalCloseBtn = $('#closeCouponsModal');
        const $modalMainBtn = $('#couponsPageModal #btn-modal-active-coupon');
        $modalCloseBtn.on('click', function () {
            $.fancybox.close($('#couponsPageModal'));
        });

        const $modal = $('#coupon-detail-modal-open');
        const START_DATE_LABEL_EN = "<strong>Start date: </strong>";
        const START_DATE_LABEL_FR = "<strong>Date de début: </strong>";
        const END_DATE_LABEL_EN = "<strong>End date: </strong>";
        const END_DATE_LABEL_FR = "<strong>Date de fin: </strong>";

        let bannerCode = $this.attr("data-cBanner");
        let typeId = $this.attr("data-cTypeId");
        let eligibilityId = $this.attr("data-cEligibilityId");

        let clickedCoupon = Coupons.getCoupon(couponList, bannerCode, typeId, eligibilityId);

        // title dollarOrPoint
        let modalCouponLine1 = $modal.find(".section-modal-coupon > h2");
        modalCouponLine1.text(clickedCoupon.dollarOrPoint);

        // dollarOrPointSubtitle
        let modalCouponLine2 = $modal.find(".section-modal-coupon > h3");
        modalCouponLine2.text(clickedCoupon.dollarOrPointSubtitle);

        // legalDescription
        let modalCouponLine3 = $modal.find(".coupon-modal-legal").prev();
        modalCouponLine3.text(clickedCoupon.legalDescription);

        // Banner
        let modalCouponBanner = $modal.find(".modal-coupon-brand");
        let couponCardBanner = $this.find(".card-tile-bottom-container").children().first();
        modalCouponBanner.empty().append(couponCardBanner.html());

        // Legal
        let modalLegalNote = $modal.find(".coupon-modal-legal > p");
        modalLegalNote.text(clickedCoupon.legalNote);

        // Dates
        let modalDateContainer = $modal.find(".modal-coupon-date");

        // StartDate
        let startDateHtml = lang === 'en' ? START_DATE_LABEL_EN : START_DATE_LABEL_FR;
        let modalStartDate = modalDateContainer.children().first();
        let formattedStartDate = Coupons.formatCouponDateToString(clickedCoupon.validityStartDate, lang);
        modalStartDate.html(startDateHtml.concat(formattedStartDate));

        // EndDate
        let endDateHtml = lang === 'en' ? END_DATE_LABEL_EN : END_DATE_LABEL_FR;
        let modalEndDate = modalStartDate.next();
        let formattedEndDate = Coupons.formatCouponDateToString(clickedCoupon.validityEndDate, lang);
        modalEndDate.html(endDateHtml.concat(formattedEndDate));

        Coupons.handleModalClipButtonState($modal, clickedCoupon, clipUrl, unclipBaseUrl, onModalSuccessCallback);

        $.fancybox.open($('#couponsPageModal'));
        $modalCloseBtn.focus();

        //ACCESSIBILITY FOCUS TRAP
        $modalCloseBtn.on('keydown', function(e) {
            if (e.shiftKey && e.keyCode === 9) {
                $modalMainBtn.focus();
            }
        });
        $modalMainBtn.on('keydown', function(e) {
            if (e.keyCode === 9 && !e.shiftKey) {
                $modalCloseBtn.focus();
            }
        });
        $(document).on('keyup', function (e) {
            if (e.keyCode === 27) {
                $.fancybox.close($('#couponsPageModal'));
            }
        });
    },
    handleModalClipButtonState: function ($modal, clickedCoupon, clipUrl, unclipBaseUrl, onModalSuccessCallback) {
        const AVAILABLE = 'AVAILABLE';
        const CLIPPED = 'CLIPPED';
        const CLIPPED_NOT_UNCLIPPABLE = 'CLIPPED_NOT_UNCLIPPABLE';

        const $buttonModal = $modal.find('#btn-modal-active-coupon');
        $buttonModal.removeClass('modal-check-icon modal-plus-icon modal-plus-mobile-icon modal-check-mobile-icon modal-check-mobile-icon modal-unclip-icon');

        if ((!isInWebview() && clickedCoupon.mobileOnlyCoupon) || clickedCoupon.status === CLIPPED_NOT_UNCLIPPABLE) {
            if (typeof lang !== 'undefined' && lang === 'en') {
                $buttonModal.text('app-exclusive coupon');
            } else {
                $buttonModal.text('exclusif à l\'appli');
            }
            $buttonModal.prop('disabled', true);
        } else {
            $buttonModal.prop('disabled', false);
        }

        // Unbind the current function on button
        $buttonModal.off();

        if (clickedCoupon.status === AVAILABLE) {
            if (clickedCoupon.mobileOnlyCoupon) {
                $buttonModal.addClass('modal-plus-mobile-icon');
            } else {
                $buttonModal.addClass('modal-plus-icon');
                if (typeof lang !== 'undefined' && lang === 'en') {
                    $buttonModal.text('add my coupon');
                } else {
                    $buttonModal.text('j\'ajoute mon coupon');
                }
                $buttonModal.on('click', function (event) {

                    let couponsToClip = [clickedCoupon];
                    $modal.addClass('in-progress');

                    $.ajax({
                        url: clipUrl,
                        type: 'PUT',
                        contentType: 'application/json',
                        data: JSON.stringify({'clippedCoupons': couponsToClip}),
                        headers: {
                            'Accept-Language': lang
                        },
                        success: function (data) {
                            onModalSuccessCallback(data, clickedCoupon);
                            pushDatalayerCouponClip(clickedCoupon.couponTypeId, clickedCoupon.bannerCode, clickedCoupon.mobileOnlyCoupon);
                        },
                        error: function (jqXHR) {
                            $modal.removeClass('in-progress');
                            TINK.redirectIfConflict(jqXHR)
                        }
                    });
                    event.stopPropagation();
                });
            }
        } else {
            if (clickedCoupon.mobileOnlyCoupon) {
                $buttonModal.addClass('modal-check-mobile-icon');
            } else {
                $buttonModal.addClass('modal-check-icon');
                if (typeof lang !== 'undefined' && lang === 'en') {
                    $buttonModal.text('coupon added');
                } else {
                    $buttonModal.text('coupon ajouté');
                }
            }

            if (clickedCoupon.status === CLIPPED) {
                if (!clickedCoupon.mobileOnlyCoupon) {
                    Coupons.handleHoverClipButtonState($buttonModal);
                }
                $buttonModal.on('click', function () {
                    $modal.addClass('in-progress');

                    $.ajax({
                        url: unclipBaseUrl + '/' + clickedCoupon.couponId + '/unclip',
                        type: 'PUT',
                        contentType: 'application/json',
                        data: JSON.stringify({
                            'couponId': clickedCoupon.couponId,
                            'status': 'Clipped',
                            'mobileOnlyCoupon': clickedCoupon.mobileOnlyCoupon
                        }),
                        headers: {
                            'Accept-Language': lang
                        },
                        success: function (data) {
                            onModalSuccessCallback(data, clickedCoupon);
                        },
                        error: function (jqXHR) {
                            $modal.removeClass('in-progress');
                            TINK.redirectIfConflict(jqXHR)
                        }
                    });
                });
            }
        }
    },
    formatCouponDateToString: function (date) {
        // Options for formatting
        const options = {year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric"};

        // Formatting date
        const formatter = new Intl.DateTimeFormat(lang, options);
        const formattedDate = formatter.format(new Date(Date.parse(date ? date : '')));

        // Adding 'le ' at the beginning of the date in French
        const output = lang === 'fr' ? 'le ' : '';

        return output.concat(`${formattedDate}`);
    },
    handleHoverClipButtonState: function ($buttonModal) {
        if ($buttonModal.prop('disabled')) {
            return;
        }

        $buttonModal.on('mouseover', function () {
            if (typeof lang !== 'undefined' && lang === 'en') {
                $buttonModal.text('remove my coupon');
            } else {
                $buttonModal.text('je retire mon coupon');
            }
            $buttonModal.addClass('modal-unclip-icon')
        });
        $buttonModal.on('mouseout', function () {
            if (typeof lang !== 'undefined' && lang === 'en') {
                $buttonModal.text('coupon added');
            } else {
                $buttonModal.text('coupon ajouté');
            }
            $buttonModal.removeClass('modal-unclip-icon')

        });
    },
    triggerCouponImpressionOnActiveCoupons: function() {
        $('.cardTileCoupon').each(function () {
            let cTypedId = $(this).attr("data-cTypeId");
            if (!window.localStorage.getItem('event-coupon-key-' + cTypedId)) {
                let cBanner = $(this).attr("data-cBanner");
                let cMobileOnly = $(this).attr("data-cMobile");
                pushEventCouponImpression(cTypedId, cBanner, cMobileOnly);
                window.localStorage.setItem('event-coupon-key-' + cTypedId, 'true');
            }
        });
    }
};
